import { SIDE_KEYWORD, ALIGNMENT_MAP } from '../constants';

/**
 * Represents a connection between two items in the configurator
 */
export default class Connector {
  constructor({
    target,
    targetLocalSide,
    alignment,
    localSide,
    insert = false,
    anytable = false,
  }) {
    if (!target) {
      throw new Error('Connector requires a target');
    }
    if (!SIDE_KEYWORD.includes(targetLocalSide)) {
      throw new Error('Invalid targetLocalSide');
    }
    if (
      !ALIGNMENT_MAP[alignment] &&
      !Object.values(ALIGNMENT_MAP).includes(alignment)
    ) {
      throw new Error('Invalid alignment');
    }
    if (localSide && !SIDE_KEYWORD.includes(localSide)) {
      throw new Error('Invalid localSide');
    }

    this.target = target;
    this.targetLocalSide = targetLocalSide;
    this.alignment = alignment;
    this.localSide = localSide;
    this.insert = insert;
    this.anytable = anytable;
  }

  /**
   * Creates a new connector with updated properties
   */
  clone(updates = {}) {
    return new Connector({
      target: this.target,
      targetLocalSide: this.targetLocalSide,
      alignment: this.alignment,
      localSide: this.localSide,
      insert: this.insert,
      anytable: this.anytable,
      ...updates,
    });
  }

  /**
   * Validates if this connector can be used to connect the given item
   */
  isValidFor(item) {
    if (!item) return false;

    // Basic validation - can be extended based on specific rules
    if (this.insert && !item._type === 'seat') return false;
    if (this.anytable && !['seat', 'anytable'].includes(item._type))
      return false;

    return true;
  }

  /**
   * Returns a plain object representation of the connector
   */
  toObject() {
    return {
      target: this.target,
      targetLocalSide: this.targetLocalSide,
      alignment: this.alignment,
      localSide: this.localSide,
      insert: this.insert,
      anytable: this.anytable,
    };
  }

  /**
   * Creates a Connector instance from a plain object
   */
  static fromObject(obj) {
    return new Connector(obj);
  }

  setAlignment(alignment) {
    this.alignment = alignment;
  }
}
